import { multicastChannel } from 'redux-saga';
// Storage event channel singleton: the initial self-call generates a
// channel, sunsequent calls to `getStorageEventChannel` fetch it
export const getStorageEventChannel = (()=>{
    const channel = multicastChannel();
    return ()=>{
        return channel;
    };
})();
